// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2ZVLi","buttons":"Footer_buttons__3IgOj"};